<template>
  <b-modal
    id="modal-print"
    ref="bModal"
    hide-footer
    centered
    :title="$t('printService.title')"
    modal-class="printModal"
    @hidden="onHidden"
  >
    <b-row class="pt-3">
      <b-col class="text-center">
        <span class="text-danger">{{ $t('printService.titleoff') }}</span>
        <p class="mt-2">
          {{ $t('printService.pdown') }}
        </p>
        <b-button
          :href="$_anapathPrinterInstallerUrl"
          size="sm"
          class="btn__outline"
        >
          <i
            class="far fa-download mr-2"
            aria-hidden="true"
          />{{ $t('printService.btndown') }}
        </b-button>
        <p class="mt-3">
          {{ $t('printService.pconf') }}
        </p>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>

export default {
    name: 'ModalPrint',
    data() {
        return {
            onHiddenAction: null
        }
    },
    methods: {
        show(onHiddenAction) {
            this.onHiddenAction = onHiddenAction
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        onHidden() {
            if (this.onHiddenAction) {
                this.onHiddenAction()
            }
        }
    }
}

</script>

<style>

.printModal .modal-body {
    border-radius: 0 0 0.3rem 0.3rem;
    height: auto;
}

.printModal .modal-dialog {
    max-width: 500px;
}

</style>
